import { ActionType } from '../../types';

export const AlarmAcknowledgementActions = {
    alarmAcknowledgementStarted: () =>
        ({
            type: 'AlarmAcknowledgement/Load/Started',
        } as const),

    alarmAcknowledgementSucceeded: (
        statusCode: number,
        status: string,
        acknowledgeUser: string,
        acknowledgeTime: string
    ) =>
        ({
            type: 'AlarmAcknowledgement/Load/Succeeded',
            payload: { statusCode, status, acknowledgeUser, acknowledgeTime },
        } as const),

    alarmAcknowledgementFailed: (statusCode: number) =>
        ({
            type: 'AlarmAcknowledgement/Load/Failed',
            payload: { statusCode },
        } as const),
    alarmAcknowledgementUnmounted: () =>
        ({
            type: 'AlarmAcknowledgement/Load/Unmounted',
        } as const),
};

export type AlarmAcknowledgementActions = ActionType<typeof AlarmAcknowledgementActions>;
